'use client';

import React from 'react';
import Header from '@/components/common/Header';
import Footer from '@/app/homepage/components/Footer';
import { useTranslation } from '@/hooks/useTranslation';

export default function CookiePolicyPage() {
    const { t } = useTranslation();

    return (
        <>
            <Header />
            <main className="min-h-screen bg-background">
                <section className="py-20 px-6 bg-gradient-to-b from-card to-background border-b border-border">
                    <div className="max-w-4xl mx-auto text-center">
                        <h1 className="text-5xl font-headline font-bold text-foreground mb-6">{t('cookiePolicyTitle')}</h1>
                        <p className="text-muted-foreground">{t('lastUpdated')}: January 11, 2026</p>
                    </div>
                </section>

                <section className="py-20 px-6">
                    <div className="max-w-4xl mx-auto prose prose-lg">
                        <div className="space-y-8 text-muted-foreground">
                            <div>
                                <h2 className="text-2xl font-headline font-bold text-foreground mb-4">{t('whatAreCookies')}</h2>
                                <p>{t('whatAreCookiesDesc')}</p>
                            </div>

                            <div>
                                <h2 className="text-2xl font-headline font-bold text-foreground mb-4">{t('howWeUseCookies')}</h2>
                                <p className="mb-3">{t('howWeUseCookiesDesc')}</p>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li><strong>{t('essentialCookies')}</strong> {t('essentialCookiesDesc')}</li>
                                    <li><strong>{t('analyticsCookies')}</strong> {t('analyticsCookiesDesc')}</li>
                                    <li><strong>{t('preferenceCookies')}</strong> {t('preferenceCookiesDesc')}</li>
                                    <li><strong>{t('marketingCookies')}</strong> {t('marketingCookiesDesc')}</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="text-2xl font-headline font-bold text-foreground mb-4">{t('managingCookies')}</h2>
                                <p>{t('managingCookiesDesc')}</p>
                            </div>

                            <div>
                                <h2 className="text-2xl font-headline font-bold text-foreground mb-4">{t('thirdPartyCookies')}</h2>
                                <p>{t('thirdPartyCookiesDesc')}</p>
                            </div>

                            <div>
                                <h2 className="text-2xl font-headline font-bold text-foreground mb-4">{t('contactUsPolicy')}</h2>
                                <p>{t('contactUsPolicyDesc')} <a href="mailto:privacy@egyptexgateway.com" className="text-primary hover:underline">privacy@egyptexgateway.com</a></p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
